module.exports = __webpack_public_path__ + "static/img/load.3365dc48.svg";